export class SiblingModel extends Backbone.AssociatedModel {
    public Id: string;
    constructor(options: any) {
        super(options);
        this.Id = options.Id;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/stage.ts